import { createApp } from 'vue';
import { initRouter } from './router';
import { setupPlugins } from './plugins';
import { setupDirectives } from './directives';
import App from './App.vue';
import './styles/tailwind.css';
import './styles/index.scss';

const app = createApp(App);

// 注册所有插件（Pinia、Element Plus、i18n等）
setupPlugins(app);

// 注册全局指令
setupDirectives(app);

// Router
initRouter(app);

app.mount('#app');
